import { Box, Typography } from '@mui/material';

import { formatPhone } from '../../utils/formatter';

const fontFamily = '"Inter", sans-serif';

const ProposalViewContacts = ({ property, selectedClientId, billingAddress }) => {
  // Get selected client or fallback to first client
  const primaryClient = selectedClientId
    ? property?.clients?.find((c) => c.client?.id === selectedClientId)?.client
    : property?.clients?.[0]?.client;
  
  return (
    <Box sx={{ mb: 4, px: 2 }}>
      <Box
        sx={{
          backgroundColor: '#f8f9fa',
          borderRadius: 1,
          p: 2,
        }}
      >
        {/* Customer */}
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 1 }}>
          <Typography
            sx={{
              fontFamily,
              fontSize: 12,
              color: '#666',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              fontWeight: 500,
            }}
          >
            Customer:
          </Typography>
          <Typography
            sx={{
              fontFamily,
              fontSize: 14,
              fontWeight: 600,
              color: '#1a1a1a',
            }}
          >
            {primaryClient?.fullName || 'Customer'}
          </Typography>
        </Box>

        {/* Location */}
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 1 }}>
          <Typography
            sx={{
              fontFamily,
              fontSize: 12,
              color: '#666',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              fontWeight: 500,
            }}
          >
            Location:
          </Typography>
          <Typography
            sx={{
              fontFamily,
              fontSize: 14,
              color: '#1a1a1a',
            }}
          >
            {property?.address || 'Address not provided'}
          </Typography>
        </Box>

        {/* Phone */}
        {primaryClient?.phoneNumber && (
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5, mb: 1 }}>
            <Typography
              sx={{
                fontFamily,
                fontSize: 12,
                color: '#666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                fontWeight: 500,
              }}
            >
              Phone:
            </Typography>
            <Typography
              sx={{
                fontFamily,
                fontSize: 14,
                color: '#1a1a1a',
              }}
            >
              {formatPhone(primaryClient.phoneNumber)}
            </Typography>
          </Box>
        )}

        {/* Email */}
        {primaryClient?.email && (
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
            <Typography
              sx={{
                fontFamily,
                fontSize: 12,
                color: '#666',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                fontWeight: 500,
              }}
            >
              Email:
            </Typography>
            <Typography
              sx={{
                fontFamily,
                fontSize: 14,
                color: '#1a1a1a',
              }}
            >
              {primaryClient.email}
            </Typography>
          </Box>
        )}
      </Box>

      {/* Billing Information */}
      {billingAddress && (
        <Box
          sx={{
            backgroundColor: '#f8f9fa',
            borderRadius: 1,
            p: 2,
            mt: 1.5,
          }}
        >
          <Typography
            sx={{
              fontFamily,
              fontSize: 12,
              color: '#666',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              fontWeight: 500,
              mb: 0.5,
            }}
          >
            Billing Information:
          </Typography>
          <Typography
            sx={{
              fontFamily,
              fontSize: 13,
              color: '#1a1a1a',
              whiteSpace: 'pre-wrap',
              lineHeight: 1.5,
            }}
          >
            {billingAddress}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ProposalViewContacts;
